import React, {useEffect} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useJobsWorkerReport } from '../../Data/Reports';
import { Sections } from '../../Components/Containers/Section';
import { PageLoading } from '../../Components/Loading';
import { selectableDateRanges } from '../../Data/DateRanges';
import { useGrants } from '../../Data/Business';
import MultiTimeSeriesChart from './Components/MultiTimeSeriesChart';
import { usePreference } from '../../Data/Preference';
import { ucFirst } from '../../Services/helpers';
import BarPieTableChart from './Components/BarPieTableChart';

const Workers = () => {
    const [dateRange, setDateRange] = usePreference('reports:workers:dateRange', 'thisMonth');
    const [show, setShow] = usePreference('reports:workers:show', 'value');
    const {report, refresh} = useJobsWorkerReport(true, {dateRange});
    const {grants} = useGrants(true);

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRange]);

    return <>
        <TopBar left="/reports"
            title="Assigned work"
            dropdownOptions={[
                {
                    section: 'Show'
                },
                {
                    title: 'Value',
                    value: 'value',
                    onClick: () => setShow('value'),
                    icon: 'value' === show ? 'CircleCheck' : 'Circle',
                },
                {
                    title: 'Count',
                    value: 'count',
                    onClick: () => setShow('count'),
                    icon: 'count' === show ? 'CircleCheck' : 'Circle',
                },
                {
                    section: 'Date Range'
                },
                ...selectableDateRanges.map(r => ({
                    title: r.label,
                    value: r.value,
                    onClick: () => setDateRange(r.value),
                    icon: r.value === dateRange ? 'CircleCheck' : 'Circle',
                }))
            ]}
        />
        <Page>
            {(report && grants) ? <Inner {...{report, grants, show}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({report, grants, show}) => {
    const getGrantName = (grt) => grants ? (grants.find(s => s.userId === grt)?.title ?? ucFirst(grt)) : grt;
    const title = show === 'count' ? 'Count' : `Sum (${show})`;
    const dataType = show === 'count' ? 'number' : 'currency';

    return <Sections>
        <MultiTimeSeriesChart title="Assigned work over time"
            subtitle={`${title} of Invoices over time`}
            data={Object.keys(report.byWorkerAndDates).map(worker => ({
                dataLabel: getGrantName(worker),
                data: report.byWorkerAndDates[worker].map(date => ({
                    label: date.date,
                    value: date[show === 'value' ? 'total' : 'count']
                }))
            }))}
            dataType={dataType}
        />
        {grants.map(grant => {
            if (!report.byWorkerAndStatus[grant.userId]) {
                return null;
            }

            return <BarPieTableChart title={grant.title}
                dataLabel="Jobs"
                groupingLabel="Status"
                subtitle={`${title} of jobs by status`}
                labelValueData={Object.values(report.byWorkerAndStatus[grant.userId])
                    .map(s => ({
                        label: s.status,
                        value: s[show === 'value' ? 'total' : 'count']
                    }))
                }
                dataType={dataType}
                defaultType="Bar"
            />
        })}
        {report.byWorkerAndStatus['unassigned'] && <BarPieTableChart title="Unassigned jobs"
                dataLabel="Jobs"
                groupingLabel="Status"
                subtitle={`${title} of jobs by status`}
                labelValueData={Object.values(report.byWorkerAndStatus['unassigned'])
                    .map(s => ({
                        label: s.status,
                        value: s[show === 'value' ? 'total' : 'count']
                    }))
                }
                dataType={dataType}
                defaultType="Bar"
            />}
    </Sections>
}

export default Workers;
